/* ============================================================
   Buchung-Funnel JS – mit Custom-Kalender
   ============================================================ */
(function () {
  'use strict';

  function injectContactForm() {
    var wrap = document.getElementById('bf-form-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.style.cssText = 'position:absolute;left:-9999px;top:-9999px;width:1px;height:1px;overflow:hidden;';
      wrap.setAttribute('aria-hidden', 'true');
      wrap.id = 'bf-form-wrap';
      document.body.appendChild(wrap);
    }
    var form = document.createElement('form');
    form.method = 'post';
    form.action = '/contact';
    form.id = 'bf-form';
    form.innerHTML =
      '<input type="hidden" name="form_type" value="contact">' +
      '<input type="hidden" name="utf8" value="\u2713">' +
      '<input type="hidden" name="return_to" value="/?contact_posted=true#bf-success">' +
      '<input type="hidden" name="contact[name]" id="bf-form-firstname" value="">' +
      '<input type="hidden" name="contact[last_name]" id="bf-form-lastname" value="">' +
      '<input type="email" name="contact[email]" id="bf-form-email" value="">' +
      '<input type="tel" name="contact[phone]" id="bf-form-phone" value="">' +
      '<textarea name="contact[body]" id="bf-form-message"></textarea>';
    wrap.appendChild(form);
  }

  var DATA_EL = document.getElementById('buchung-data');
  if (!DATA_EL) return;
  var DATA;
  try { DATA = JSON.parse(DATA_EL.textContent); }
  catch (e) { console.error('Buchung: konnte Daten nicht laden', e); return; }

  var STANDORTE = DATA.standorte || [];
  var state = { step: 1, standortHandle: null, productId: null, presetProductHandle: null, date: null, time: null };
  var calState = { year: 0, month: 0 };

  // nextBtn wird nach init() gesetzt, damit renderCalendar/renderSlots darauf zugreifen koennen
  var nextBtn = null;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
  function findStandort(handle) { return STANDORTE.find(function(s){ return s.handle === handle; }) || null; }
  function findProduct(standort, productId) {
    if (!standort) return null;
    return (standort.products || []).find(function(p){ return p.id === productId; }) || null;
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function toDateStr(d) { return d.getFullYear() + '-' + pad(d.getMonth()+1) + '-' + pad(d.getDate()); }
  function getMinDate() { var d = new Date(); d.setDate(d.getDate()+1); return toDateStr(d); }
  function getMaxDate() { var d = new Date(); d.setDate(d.getDate()+14); return toDateStr(d); }
  function getDayIndex(dateStr) {
    var p = dateStr.split('-');
    return new Date(Number(p[0]), Number(p[1])-1, Number(p[2])).getDay();
  }
  function formatDateDe(dateStr) {
    if (!dateStr) return '';
    var p = dateStr.split('-');
    var d = new Date(Number(p[0]), Number(p[1])-1, Number(p[2]));
    var days = ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'];
    var months = ['Januar','Februar','M\u00e4rz','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];
    return days[d.getDay()] + ', ' + d.getDate() + '. ' + months[d.getMonth()] + ' ' + d.getFullYear();
  }

  function parseOpeningHours(text) {
    if (!text) return null;
    var lower = text.toLowerCase();
    var days = {0:false,1:false,2:false,3:false,4:false,5:false,6:false};
    if (/mo[-\s]*fr|montag\s*bis\s*freitag|werktags/.test(lower)) {
      days[1]=days[2]=days[3]=days[4]=days[5]=true;
    } else {
      if (/\bmo\b|montag/.test(lower)) days[1]=true;
      if (/\bdi\b|dienstag/.test(lower)) days[2]=true;
      if (/\bmi\b|mittwoch/.test(lower)) days[3]=true;
      if (/\bdo\b|donnerstag/.test(lower)) days[4]=true;
      if (/\bfr\b|freitag/.test(lower)) days[5]=true;
      if (/\bsa\b|samstag/.test(lower)) days[6]=true;
      if (/\bso\b|sonntag/.test(lower)) days[0]=true;
      if (!Object.keys(days).some(function(k){return days[k];})) days[1]=days[2]=days[3]=days[4]=days[5]=true;
    }
    var m = text.match(/(\d{1,2})(?::(\d{2}))?\s*[-\u2013\u2014bis]+\s*(\d{1,2})(?::(\d{2}))?/);
    if (!m) return null;
    var sh = parseInt(m[1],10), eh = parseInt(m[3],10);
    if (isNaN(sh)||isNaN(eh)||eh-1<sh) return null;
    var slots = [];
    for (var h=sh; h<=eh-1; h++) slots.push(pad(h)+':00');
    return {days:days, slots:slots};
  }

  function getSlotsForDate(standortHandle, dateStr) {
    var s = findStandort(standortHandle);
    if (!s) return {open:false,slots:[]};
    var parsed = parseOpeningHours(s.opening_hours);
    if (!parsed) return {open:false,slots:[]};
    if (!parsed.days[getDayIndex(dateStr)]) return {open:false,slots:[]};
    return {open:true,slots:parsed.slots};
  }

  function isDateOpen(standortHandle, dateStr) {
    return getSlotsForDate(standortHandle, dateStr).open;
  }

  // updateNextEnabled ist global damit renderSlots und renderCalendar es nutzen koennen
  function updateNextEnabled() {
    if (!nextBtn) return;
    var ok = false;
    if (state.step === 1) ok = !!state.standortHandle;
    else if (state.step === 2) ok = !!state.productId;
    else if (state.step === 3) ok = !!(state.date && state.time);
    nextBtn.disabled = !ok;
  }

  /* ============================================================
     CUSTOM KALENDER
     ============================================================ */
  var MONTH_NAMES = ['Januar','Februar','M\u00e4rz','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];
  var WD_NAMES = ['Mo','Di','Mi','Do','Fr','Sa','So'];

  function renderCalendar(container, standortHandle) {
    var today = new Date();
    var minDate = getMinDate();
    var maxDate = getMaxDate();

    if (!calState.year) {
      var minD = new Date(minDate);
      calState.year = minD.getFullYear();
      calState.month = minD.getMonth();
    }

    function buildCalendar() {
      container.innerHTML = '';
      var cal = document.createElement('div');
      cal.className = 'bf-cal';

      // Kopfzeile
      var head = document.createElement('div');
      head.className = 'bf-cal__head';

      var btnPrev = document.createElement('button');
      btnPrev.type = 'button';
      btnPrev.className = 'bf-cal__nav';
      btnPrev.setAttribute('aria-label', 'Vorheriger Monat');
      btnPrev.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';

      var monthLabel = document.createElement('div');
      monthLabel.className = 'bf-cal__month';
      monthLabel.textContent = MONTH_NAMES[calState.month] + ' ' + calState.year;

      var btnNext = document.createElement('button');
      btnNext.type = 'button';
      btnNext.className = 'bf-cal__nav';
      btnNext.setAttribute('aria-label', 'N\u00e4chster Monat');
      btnNext.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';

      var minD2 = new Date(minDate);
      var maxD2 = new Date(maxDate);
      btnPrev.disabled = (new Date(calState.year, calState.month, 1) <= new Date(minD2.getFullYear(), minD2.getMonth(), 1));
      btnNext.disabled = (new Date(calState.year, calState.month+1, 0) >= maxD2);

      btnPrev.addEventListener('click', function() {
        calState.month--;
        if (calState.month < 0) { calState.month = 11; calState.year--; }
        buildCalendar();
      });
      btnNext.addEventListener('click', function() {
        calState.month++;
        if (calState.month > 11) { calState.month = 0; calState.year++; }
        buildCalendar();
      });

      head.appendChild(btnPrev);
      head.appendChild(monthLabel);
      head.appendChild(btnNext);
      cal.appendChild(head);

      // Wochentage
      var wdRow = document.createElement('div');
      wdRow.className = 'bf-cal__weekdays';
      WD_NAMES.forEach(function(wd) {
        var cell = document.createElement('div');
        cell.className = 'bf-cal__wd';
        cell.textContent = wd;
        wdRow.appendChild(cell);
      });
      cal.appendChild(wdRow);

      // Tage-Grid
      var daysGrid = document.createElement('div');
      daysGrid.className = 'bf-cal__days';

      var firstDay = new Date(calState.year, calState.month, 1).getDay();
      var startOffset = (firstDay + 6) % 7; // Mo=0 ... So=6

      for (var e = 0; e < startOffset; e++) {
        var empty = document.createElement('div');
        empty.className = 'bf-cal__day bf-cal__day--empty';
        daysGrid.appendChild(empty);
      }

      var daysInMonth = new Date(calState.year, calState.month+1, 0).getDate();

      for (var d = 1; d <= daysInMonth; d++) {
        (function(day) {
          var dateStr = calState.year + '-' + pad(calState.month+1) + '-' + pad(day);
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'bf-cal__day';
          btn.textContent = day;

          if (dateStr === toDateStr(today)) btn.classList.add('bf-cal__day--today');
          if (dateStr === state.date) btn.classList.add('bf-cal__day--selected');

          var inRange = (dateStr >= minDate && dateStr <= maxDate);

          if (!inRange) {
            btn.disabled = true;
          } else if (!isDateOpen(standortHandle, dateStr)) {
            btn.classList.add('bf-cal__day--closed');
            btn.disabled = true;
          } else {
            btn.addEventListener('click', function() {
              state.date = dateStr;
              state.time = null;
              buildCalendar();
              renderSlots(standortHandle);
              // updateNextEnabled hier: date gesetzt aber time noch null -> disabled, korrekt
              updateNextEnabled();
            });
          }

          daysGrid.appendChild(btn);
        })(d);
      }

      cal.appendChild(daysGrid);

      // Legende
      var legend = document.createElement('div');
      legend.className = 'bf-cal__legend';
      legend.innerHTML =
        '<div class="bf-cal__legend-item"><div class="bf-cal__legend-dot bf-cal__legend-dot--available"></div>Buchbar</div>' +
        '<div class="bf-cal__legend-item"><div class="bf-cal__legend-dot bf-cal__legend-dot--closed"></div>Geschlossen</div>';
      cal.appendChild(legend);

      container.appendChild(cal);
    }

    buildCalendar();
  }

  // renderSlots ist global und nutzt das globale nextBtn/updateNextEnabled
  function renderSlots(standortHandle) {
    var timesEl = $('#bf-times');
    if (!timesEl) return;
    timesEl.innerHTML = '';

    if (!state.date) {
      timesEl.innerHTML = '<div class="bf-times-empty">Bitte zuerst ein Datum w\u00e4hlen.</div>';
      return;
    }
    var info = getSlotsForDate(standortHandle, state.date);
    if (!info.open || !info.slots.length) {
      timesEl.innerHTML = '<div class="bf-times-empty">An diesem Tag geschlossen.</div>';
      return;
    }
    info.slots.forEach(function(slot) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bf-time';
      if (slot === state.time) btn.classList.add('bf-time--selected');
      btn.textContent = slot;
      btn.addEventListener('click', function() {
        state.time = slot;
        renderSlots(standortHandle);  // neu rendern fuer selected-Highlighting
        updateNextEnabled();          // jetzt date + time gesetzt -> Weiter aktiv!
      });
      timesEl.appendChild(btn);
    });
  }

  /* ============================================================
     INIT
     ============================================================ */
  function init() {
    var modal = $('#bf-modal');
    if (!modal) return;
    injectContactForm();

    var closeBtn = $('.bf__close', modal);
    var backdrop = $('.bf__backdrop', modal);
    nextBtn = $('#bf-next');  // globale Variable setzen!
    var prevBtn = $('#bf-prev');
    var submitBtn = $('#bf-submit');
    var newBtn = $('#bf-new');
    var triggers = $$('.bf-trigger, [data-bf-open]');
    var step1=$('#bf-step-1'), step2=$('#bf-step-2'), step3=$('#bf-step-3'), step4=$('#bf-step-4'), step5=$('#bf-step-5');
    var progressSteps = $$('.bf__progress-step');

    function openModal(opts) {
      opts = opts || {};
      resetState();
      if (opts.productHandle && opts.standortHandle) {
        var s = findStandort(opts.standortHandle);
        var p = s ? (s.products||[]).find(function(pr){return pr.handle===opts.productHandle;}) : null;
        if (s && p) { state.standortHandle=s.handle; state.productId=p.id; goToStep(3); }
        else goToStep(1);
      } else if (opts.productHandle) {
        state.presetProductHandle = opts.productHandle; goToStep(1);
      } else if (opts.standortHandle) {
        var s2 = findStandort(opts.standortHandle);
        if (s2) { state.standortHandle=s2.handle; goToStep(2); } else goToStep(1);
      } else { goToStep(1); }
      modal.classList.add('bf--open');
      document.body.classList.add('bf-open');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.remove('bf--open');
      document.body.classList.remove('bf-open');
      document.body.style.overflow = '';
    }

    function resetState() {
      state = {step:1,standortHandle:null,productId:null,presetProductHandle:null,date:null,time:null};
      calState = {year:0,month:0};
      $$('input',modal).forEach(function(i){ if(i.type==='checkbox') i.checked=false; else if(i.type!=='hidden') i.value=''; });
      var ta=$('#bf-message'); if(ta) ta.value='';
      if(submitBtn){submitBtn.disabled=false;submitBtn.innerHTML='Kostenlose Probefahrt buchen';}
      var errEl=$('#bf-form-error'); if(errEl) errEl.classList.remove('bf-error--visible');
    }

    function goToStep(n) {
      state.step = n;
      [step1,step2,step3,step4,step5].forEach(function(el,i){ if(!el) return; el.classList.toggle('bf__step--active', i+1===n); });
      progressSteps.forEach(function(el,i){
        el.classList.remove('bf__progress-step--done','bf__progress-step--current');
        if(i+1<n) el.classList.add('bf__progress-step--done');
        else if(i+1===n) el.classList.add('bf__progress-step--current');
      });
      var foot=$('.bf__foot',modal);
      if(n===5) foot.style.display='none'; else foot.style.display='';
      prevBtn.style.visibility=(n===1||n===5)?'hidden':'visible';
      nextBtn.style.display=(n===4)?'none':'inline-flex';
      submitBtn.style.display=(n===4)?'inline-flex':'none';
      if(n===1) renderStandorte();
      if(n===2) renderProducts();
      if(n===3) renderDateTime();
      if(n===4) renderSummary();
      updateNextEnabled();
    }

    function renderStandorte(filter) {
      var list=$('#bf-standorte-list'); if(!list) return;
      list.innerHTML='';
      var q=(filter||'').toLowerCase().trim();
      var filtered=STANDORTE.filter(function(s){ return !q||(s.zip+' '+s.city+' '+s.name).toLowerCase().indexOf(q)!==-1; });
      if(!filtered.length){ list.innerHTML='<div class="bf-empty">Keine Standorte gefunden.</div>'; return; }
      filtered.forEach(function(s){
        var btn=document.createElement('button'); btn.type='button'; btn.className='bf-standort';
        if(s.handle===state.standortHandle) btn.classList.add('bf-standort--selected');
        btn.innerHTML=
          '<span class="bf-standort__icon" aria-hidden="true"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 7-8 13-8 13s-8-6-8-13a8 8 0 0 1 16 0z"/><circle cx="12" cy="10" r="3"/></svg></span>'+
          '<span class="bf-standort__info"><span class="bf-standort__name">'+escapeHtml(s.name)+'</span><span class="bf-standort__addr">'+escapeHtml(s.zip+' '+s.city)+'</span></span>'+
          '<span class="bf-standort__check" aria-hidden="true"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>';
        btn.addEventListener('click', function(){
          if(state.standortHandle!==s.handle){state.productId=null;state.date=null;state.time=null;}
          state.standortHandle=s.handle;
          if(state.presetProductHandle){
            var preP=(s.products||[]).find(function(pr){return pr.handle===state.presetProductHandle;});
            if(preP) state.productId=preP.id;
          }
          renderStandorte(q); updateNextEnabled();
        });
        list.appendChild(btn);
      });
    }

    function renderProducts() {
      var list=$('#bf-products-list'), info=$('#bf-products-info'); if(!list) return;
      list.innerHTML='';
      var s=findStandort(state.standortHandle); if(!s) return;
      if(info) info.textContent='Verf\u00fcgbar an '+s.name;
      var products=s.products||[];
      if(!products.length){list.innerHTML='<div class="bf-empty">Keine Testprodukte verf\u00fcgbar.</div>';return;}
      products.forEach(function(p){
        var btn=document.createElement('button'); btn.type='button'; btn.className='bf-product';
        if(p.id===state.productId) btn.classList.add('bf-product--selected');
        var img=p.image?'<img src="'+p.image+'" alt="'+escapeHtml(p.title)+'" loading="lazy">':'';
        btn.innerHTML=
          '<div class="bf-product__media">'+img+'</div>'+
          '<div class="bf-product__title">'+escapeHtml(p.title)+'</div>'+
          '<span class="bf-product__check" aria-hidden="true"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>';
        btn.addEventListener('click', function(){
          if(state.productId!==p.id){state.date=null;state.time=null;}
          state.productId=p.id; renderProducts(); updateNextEnabled();
        });
        list.appendChild(btn);
      });
    }

    function renderDateTime() {
      var dateInfo=$('#bf-date-info');
      var calContainer=$('#bf-cal-container');
      var s=findStandort(state.standortHandle);
      var p=findProduct(s,state.productId);
      if(dateInfo&&s&&p) dateInfo.textContent=p.title+' \u2022 '+s.name;
      if(calContainer) renderCalendar(calContainer, state.standortHandle);
      renderSlots(state.standortHandle);
    }

    function renderSummary() {
      var summary=$('#bf-summary'); if(!summary) return;
      var s=findStandort(state.standortHandle), p=findProduct(s,state.productId);
      summary.innerHTML=
        '<div class="bf-summary__row"><span class="bf-summary__icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 7-8 13-8 13s-8-6-8-13a8 8 0 0 1 16 0z"/><circle cx="12" cy="10" r="3"/></svg></span><span class="bf-summary__label">Standort</span><span class="bf-summary__value">'+escapeHtml(s?s.name:'')+'</span></div>'+
        '<div class="bf-summary__row"><span class="bf-summary__icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="20 6 9 17 4 12"/></svg></span><span class="bf-summary__label">Produkt</span><span class="bf-summary__value">'+escapeHtml(p?p.title:'')+'</span></div>'+
        '<div class="bf-summary__row"><span class="bf-summary__icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg></span><span class="bf-summary__label">Termin</span><span class="bf-summary__value">'+escapeHtml(formatDateDe(state.date))+' \u00b7 '+escapeHtml(state.time||'')+' Uhr</span></div>';
    }

    function fillFormFields() {
      var fn=$('#bf-firstname').value.trim(), ln=$('#bf-lastname').value.trim();
      var em=$('#bf-email').value.trim(), ph=$('#bf-phone').value.trim(), msg=$('#bf-message').value.trim();
      var s=findStandort(state.standortHandle), p=findProduct(s,state.productId);
      $('#bf-form-firstname').value=fn; $('#bf-form-lastname').value=ln;
      $('#bf-form-email').value=em; $('#bf-form-phone').value=ph;
      $('#bf-form-message').value=
        'PROBEFAHRT-ANFRAGE\n====================\n\n'+
        'Standort: '+(s?s.name:'')+'\n'+
        '   Adresse: '+(s?(s.street+', '+s.zip+' '+s.city):'')+'\n'+
        '   Telefon: '+(s?s.phone:'')+'\n'+
        '   E-Mail:  '+(s?s.email:'')+'\n\n'+
        'Produkt:  '+(p?p.title:'')+'\n'+
        'Produkt-ID: '+(p?p.id:'')+'\n\n'+
        'Wunschtermin: '+formatDateDe(state.date)+', '+state.time+' Uhr\n\n'+
        '--- Kunde ---\nName: '+fn+' '+ln+'\nE-Mail: '+em+'\nTelefon: '+ph+'\n\n'+
        (msg?'--- Wunschnachricht ---\n'+msg+'\n':'');
    }

    function submitBooking() {
      var fn=$('#bf-firstname').value.trim(), ln=$('#bf-lastname').value.trim();
      var em=$('#bf-email').value.trim(), ph=$('#bf-phone').value.trim();
      var privacy=$('#bf-privacy').checked, errEl=$('#bf-form-error');
      var errors=[];
      if(!fn) errors.push('Bitte gib deinen Vornamen an.');
      if(!ln) errors.push('Bitte gib deinen Nachnamen an.');
      if(!em||!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em)) errors.push('Bitte gib eine g\u00fcltige E-Mail-Adresse an.');
      if(!ph) errors.push('Bitte gib deine Telefonnummer an.');
      if(!privacy) errors.push('Bitte best\u00e4tige die Datenschutzerkl\u00e4rung.');
      if(errors.length){errEl.textContent=errors[0];errEl.classList.add('bf-error--visible');return;}
      errEl.classList.remove('bf-error--visible');
      var form=$('#bf-form'); if(!form) return;
      submitBtn.disabled=true; submitBtn.textContent='Wird gesendet \u2026';
      function actuallySubmit(){
        fillFormFields();
        try{form.submit();}catch(err){
          submitBtn.disabled=false; submitBtn.textContent='Kostenlose Probefahrt buchen';
          errEl.textContent='Etwas ist schiefgelaufen. Bitte nochmal versuchen.';
          errEl.classList.add('bf-error--visible');
        }
      }
      function tryProtect(){
        if(window.Shopify&&window.Shopify.captcha&&typeof window.Shopify.captcha.protect==='function'){
          try{window.Shopify.captcha.protect(form,function(){actuallySubmit();});return;}catch(e){}
        }
        actuallySubmit();
      }
      try{var fe=form.querySelector('#bf-form-email');if(fe){fe.dispatchEvent(new Event('focus',{bubbles:true}));}}catch(e){}
      setTimeout(tryProtect,350);
    }

    function escapeHtml(str){
      if(str==null) return '';
      return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
    }

    triggers.forEach(function(t){
      t.addEventListener('click',function(e){
        e.preventDefault();
        openModal({standortHandle:t.getAttribute('data-test-standort')||null, productHandle:t.getAttribute('data-test-product-handle')||null});
      });
    });

    if(closeBtn) closeBtn.addEventListener('click',closeModal);
    if(backdrop) backdrop.addEventListener('click',closeModal);
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&modal.classList.contains('bf--open'))closeModal();});
    if(nextBtn) nextBtn.addEventListener('click',function(){if(state.step<4)goToStep(state.step+1);});
    if(prevBtn) prevBtn.addEventListener('click',function(){if(state.step>1)goToStep(state.step-1);});
    if(submitBtn) submitBtn.addEventListener('click',submitBooking);
    if(newBtn) newBtn.addEventListener('click',function(){resetState();goToStep(1);});
    var zipSearch=$('#bf-zip-search');
    if(zipSearch) zipSearch.addEventListener('input',function(){renderStandorte(zipSearch.value);});

    if(window.location.search.indexOf('contact_posted=true')!==-1&&window.location.hash==='#bf-success'){openModal();goToStep(5);}

    document.addEventListener('click',function(e){
      var btn=e.target.closest('[data-test-standort]');
      if(!btn||btn.classList.contains('bf-trigger')||btn.hasAttribute('data-bf-open')) return;
      e.preventDefault();
      openModal({standortHandle:btn.getAttribute('data-test-standort'), productHandle:btn.getAttribute('data-test-product-handle')});
    });

    // HINT-KARTE
    var HINT_KEY='bf:hintDismissed', HINT_DELAY=5000, HINT_HOURS=24;
    function isHintDismissed(){try{var r=localStorage.getItem(HINT_KEY);if(!r)return false;return (Date.now()-parseInt(r,10))/3600000<HINT_HOURS;}catch(e){return false;}}
    function markHintDismissed(){try{localStorage.setItem(HINT_KEY,String(Date.now()));}catch(e){}}
    function getCurrentProductHandle(){
      var m=(window.location.pathname||'').match(/\/products\/([^\/\?#]+)/);if(m)return m[1];
      var b=document.body.getAttribute('data-product-handle');if(b)return b;
      try{if(window.ShopifyAnalytics&&window.ShopifyAnalytics.meta&&window.ShopifyAnalytics.meta.product)return window.ShopifyAnalytics.meta.product.handle;}catch(e){}
      return null;
    }
    function findProductHandleInTestproducts(){
      var h=getCurrentProductHandle();if(!h)return null;
      for(var i=0;i<STANDORTE.length;i++){var ps=STANDORTE[i].products||[];for(var j=0;j<ps.length;j++){if(ps[j].handle===h)return h;}}
      return null;
    }
    var hintEl=$('#bf-hint'),hintCloseEl=$('#bf-hint-close'),triggerEl=$('.bf-trigger');
    function showHint(ph){
      if(!hintEl)return;hintEl.hidden=false;void hintEl.offsetWidth;hintEl.classList.add('bf-hint--visible');
      if(triggerEl)triggerEl.classList.add('bf-trigger--pulse');
      hintEl.addEventListener('click',function(e){if(e.target.closest('#bf-hint-close'))return;hideHint();openModal({productHandle:ph});});
    }
    function hideHint(persist){
      if(!hintEl)return;hintEl.classList.remove('bf-hint--visible');
      if(triggerEl)triggerEl.classList.remove('bf-trigger--pulse');
      setTimeout(function(){hintEl.hidden=true;},400);
      if(persist)markHintDismissed();
    }
    if(hintCloseEl)hintCloseEl.addEventListener('click',function(e){e.stopPropagation();hideHint(true);});
    triggers.forEach(function(t){t.addEventListener('click',function(){if(hintEl&&!hintEl.hidden)hideHint(false);});});
    if(!isHintDismissed()){
      var mh=findProductHandleInTestproducts();
      if(mh)setTimeout(function(){if(!modal.classList.contains('bf--open'))showHint(mh);},HINT_DELAY);
    }
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();

})();
